export const DND_COLORS = {
  dropTargetPrimary: 'rgba(25, 118, 210, 0.8)',
  dropTargetBackground: 'rgba(25, 118, 210, 0.1)',
  dropTargetTransparent: 'rgba(0, 0, 0, 0)',
} as const;

export const DND_OPACITY = {
  dragging: 0.4,
  draggingLight: 0.5,
  normal: 1,
} as const;

export const DND_TRANSITIONS = {
  fast: 'all 0.15s ease',
  medium: 'all 0.2s ease',
} as const;

export const DND_CURSORS = {
  grab: 'grab',
  grabbing: 'grabbing',
  default: 'default',
} as const;

export const DND_SENSOR_CONFIG = {
  activationConstraint: {
    distance: 1,
  },
} as const;

export const DND_NO_SELECT_STYLES = {
  userSelect: 'none',
  WebkitUserSelect: 'none',
} as const;
